import { Component, EventEmitter, Output } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { UtilsProvider } from '../../providers/utils/utils';
import { ReservasProvider } from '../../providers/reservas/reservas';

@IonicPage()
@Component({
  selector: 'page-gestion-cambio-precio-por-producto',
  templateUrl: 'gestion-cambio-precio-por-producto.html',
  providers:[ReservasProvider]
})
export class GestionCambioPrecioPorProductoPage {
  listaProductosSeleccionados = []
  listaTurno = []
  valorTotalVenta = 0
  refactorizarPedidosSalon: boolean = false
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public viewControllers:ViewController, public utils:UtilsProvider,
    public reservasProvider: ReservasProvider) {
    if(this.navParams.get('data')){
      let cambiarPrecioEnLosProductos = this.navParams.get('cambiarPrecioEnLosProductos')
      if(!cambiarPrecioEnLosProductos) {
        this.utils.mensajeMuestro('Actualizar precio','Usted no tiene permisos para actualizar el precio a los productos','warning')
        this.viewControllers.dismiss([this.listaProductosSeleccionados, {refactorizarPedidosSalon:this.refactorizarPedidosSalon}]);
        return
      }
      this.listaProductosSeleccionados = this.navParams.get('data')
      this.refactorizarPedidosSalon = this.navParams.get('refactorizarPedidosSalon')
      this.valorTotalVenta = this.navParams.get('valorTotalVenta')
      this.gestionReservas(this.listaProductosSeleccionados);
      if(this.listaProductosSeleccionados.length == 0) {
        this.utils.mensajeMuestro('Actualizar precio','Debe tener un producto seleccionado para poder actualizarle el precio','warning')
        this.viewControllers.dismiss([this.listaProductosSeleccionados, {refactorizarPedidosSalon:this.refactorizarPedidosSalon}]);
      }
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad GestionCambioPrecioPorProductoPage');
  }

  dismiss(){
    this.viewControllers.dismiss([this.listaProductosSeleccionados, {refactorizarPedidosSalon:this.refactorizarPedidosSalon}]);
  }

  submit(){
   this.viewControllers.dismiss([this.listaProductosSeleccionados, {refactorizarPedidosSalon:this.refactorizarPedidosSalon}]);
  }
  seleccionarElementoCheck(elemento: any, index: any) {
    this.listaProductosSeleccionados[index].color = '#1E078E'
   }
   searchSimple(cantidadafnSimple:any,item,index){
    setTimeout(() => {
        if(Number(cantidadafnSimple['_value'])==0 || isNaN(cantidadafnSimple['_value']) ){
         return
       }

       let cantidadInput = cantidadafnSimple['_value'];

        if (isNaN(cantidadInput)) {
          cantidadInput = 0;
          cantidadafnSimple['_value'] = 0;
          return
        }

       let cantidad = Number(cantidadafnSimple['_value'])

       let nuevaCantidad = Number(cantidad)

       index = this.buscarIndex(item,index,nuevaCantidad)
       return



     },1000)
   }

   buscarIndex(item:any,index:any,nuevaValor: number){
    let id  = Number(index)

    let tipoProducto  = item['tipoProducto']
    let productosId = item['productosId']
    let indexNuevo = 0
    let valorVentasTotalProductoNuevo = 0
    let ValorProductoVentas = 0
    let ValorSumoImpuesto = 0

            for(let k = 0;k < this.listaProductosSeleccionados.length;k++){
              if(this.listaProductosSeleccionados[k].productosId == productosId && this.listaProductosSeleccionados[k].tipoProducto == tipoProducto){
                  valorVentasTotalProductoNuevo += Number(nuevaValor) * this.listaProductosSeleccionados[k].cantidad
                  let valorImpuestoCalculado = this.listaProductosSeleccionados[k].valorImpuestoCalculo === undefined ?
                  this.listaProductosSeleccionados[k].valorImpuesto : this.listaProductosSeleccionados[k].valorImpuestoCalculo
                  ValorProductoVentas = Math.round(nuevaValor / ((valorImpuestoCalculado / 100)+1))
                  ValorSumoImpuesto =  nuevaValor - Math.round(nuevaValor / ((valorImpuestoCalculado / 100)+1))
                  this.listaProductosSeleccionados[k].valorTotalVenta = Number(nuevaValor) * this.listaProductosSeleccionados[k].cantidad
                  this.listaProductosSeleccionados[k].valorProducto = ValorProductoVentas
                  this.listaProductosSeleccionados[k].valorVenta = Number(nuevaValor)
                  this.listaProductosSeleccionados[k].valorImpuesto = ValorSumoImpuesto
                  this.refactorizarPedidosSalon = true
              } else {
                valorVentasTotalProductoNuevo += Number(this.listaProductosSeleccionados[k].valorVenta) * this.listaProductosSeleccionados[k].cantidad
                this.listaProductosSeleccionados[k].valorTotalVenta = Number(this.listaProductosSeleccionados[k].valorVenta) * this.listaProductosSeleccionados[k].cantidad

                let valorImpuestoCalculado = this.listaProductosSeleccionados[k].valorImpuestoCalculo === undefined ?
                this.listaProductosSeleccionados[k].valorImpuesto : this.listaProductosSeleccionados[k].valorImpuestoCalculo
                ValorProductoVentas = Math.round(this.listaProductosSeleccionados[k].valorVenta / ((valorImpuestoCalculado / 100)+1))
                ValorSumoImpuesto =  this.listaProductosSeleccionados[k].valorVenta - Math.round(this.listaProductosSeleccionados[k].valorVenta / ((valorImpuestoCalculado / 100)+1))
                this.listaProductosSeleccionados[k].valorTotalVenta = Number(this.listaProductosSeleccionados[k].valorVenta) * this.listaProductosSeleccionados[k].cantidad
                this.listaProductosSeleccionados[k].valorProducto = ValorProductoVentas
                this.listaProductosSeleccionados[k].valorVenta = Number(this.listaProductosSeleccionados[k].valorVenta)
                this.listaProductosSeleccionados[k].valorImpuesto = ValorSumoImpuesto
              }
              }
    this.valorTotalVenta = valorVentasTotalProductoNuevo
    return indexNuevo
  }
  gestionReservas(lista: any) {
    this.listaTurno = lista
    let companiasId = this.listaTurno[0].companiasId
    let turno = this.listaTurno[0].turno
    this.reservasProvider.calcularValorLiquidarReservas(companiasId,turno)
    .subscribe((res)=> {
        let data =  JSON.parse(res['_body']).data[0] === undefined ? [] : JSON.parse(res['_body']).data
        this.listaTurno = data[0]
    }, (error) => {
      console.log(error)
    })

  }

  actualizarValor(event: any) {
    let lista = this.listaProductosSeleccionados
    console.log(event)
    console.log(lista)

    this.buscarIndex(this.listaProductosSeleccionados[0],0,event.valor)
    this.listaProductosSeleccionados.forEach((producto, index) => {
      if (producto.productosId === event.id && producto.turno === event.turno) {
          this.buscarIndex(producto, index, event.valor);
      }
  });
  }
}



// WEBPACK FOOTER //
// ./src/pages/gestion-cambio-precio-por-producto/gestion-cambio-precio-por-producto.ts